import { actionTypes} from '../actions/ratesHistory'
import createAsyncReducer from './HOCreducer'

export default createAsyncReducer(actionTypes, true, { isActive: true, id: 'to_currency_id'})
